<tt-page *ngIf="!!edit">
    <ng-container *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="editReleaseNote"></ng-container>
        </tt-card>
    </ng-container>

    <ng-container *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card *ngIf="p2ReleaseNoteKeyno === '0'" ttHeading="h_release_note_new">
            <ng-container *ngTemplateOutlet="editReleaseNote"></ng-container>
        </tt-card>

        <tt-card *ngIf="p2ReleaseNoteKeyno !== '0'" ttHeading="h_release_note_edit">
            <ng-container *ngTemplateOutlet="editReleaseNote"></ng-container>
        </tt-card>
    </ng-container>
</tt-page>

<ng-template #editReleaseNote>
    <ng-container *ngIf="!!edit">
        <tt-datetime ttLabel="reg_datetime"
                     [ttModel]="edit.reg_datetime"
                     ttMinutePrecision="1"
                     ttReadonly>
        </tt-datetime>
        <tt-textarea ttLabel="description" [(ttModel)]="edit.public_note"></tt-textarea>
        <tt-input *ngIf="!!edit.video_url"
                  ttLabel="video_url"
                  [ttModel]="edit.video_url"
                  [ttButtons]="videoUrlButtons"
                  ttReadonly>
        </tt-input>
        <tt-select *ngIf="edit.show === '0'"
                   ttLabel="releasetype"
                   [ttModel]="edit.releasetype"
                   [ttData]="releaseTypes"
                   ttDataId="releasetype"
                   ttDataName="releasetype_name"
                   ttReadonly>
        </tt-select>

        <ng-container *ngIf="edit.show === '1'">
            <tt-textarea ttLabel="internal_note" [(ttModel)]="edit.internal_note"></tt-textarea>
            <tt-input ttLabel="portal_user_name" [ttModel]="edit.portal_user_name" ttReadonly></tt-input>
            <tt-select ttLabel="releasetype"
                       [(ttModel)]="edit.releasetype"
                       [ttData]="releaseTypes"
                       ttDataId="releasetype"
                       ttDataName="releasetype_name">
            </tt-select>
            <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        </ng-container>
    </ng-container>
</ng-template>
